import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import SEOSchema from '@/components/feature/SEOSchema';

export default function ContactPage() {
  return (
    <div className="min-h-screen bg-background-50">
      <SEOSchema
        type="page"
        title="Contact KakobuySheet - Get in Touch About Kakobuy Spreadsheet"
        description="Contact KakobuySheet for Kakobuy Spreadsheet inquiries, link updates, resource suggestions, or safety concerns. Reach our team through kaspreadsheet.com."
        url="https://kakobuy.boutique/contact"
        dateModified="2026-06-25"
      />
      <Navbar />
      <main className="pt-24 pb-16 md:pt-28 md:pb-20">
        <div className="max-w-[900px] mx-auto px-6 md:px-10">
          <nav className="flex items-center gap-2 text-xs md:text-sm text-foreground-400 mb-6">
            <Link to="/" className="hover:text-primary-600 transition-colors">Home</Link>
            <i className="ri-arrow-right-s-line"></i>
            <span className="text-foreground-700 font-medium">Contact</span>
          </nav>
          <h1 className="text-3xl md:text-5xl font-heading font-bold text-foreground-950 mb-6">Contact Us</h1>
          <div className="prose-custom space-y-5 text-foreground-700 leading-relaxed text-base md:text-lg">
            <p>Have questions about the <strong>Kakobuy Spreadsheet</strong>? Want to report a broken link or suggest a new resource? We would love to hear from you. Our team is dedicated to maintaining the most accurate and helpful spreadsheet directory available, and user feedback plays an essential role in that mission.</p>
            <p>For general inquiries, spreadsheet suggestions, or link updates, please reach out through the main website at <a href="https://kaspreadsheet.com/" target="_blank" rel="noopener nofollow" className="text-primary-600 hover:text-primary-700 underline">kaspreadsheet.com</a>. Our team typically responds within 24-48 hours on business days.</p>
            <h2 className="text-2xl font-heading font-bold text-foreground-950 mt-8 mb-4">Frequently Asked Contact Topics</h2>
            <ul className="list-disc pl-5 space-y-2">
              <li><strong>Link Updates:</strong> If you notice a broken or outdated Kakobuy Spreadsheet link, please contact us with the category and specific entry details.</li>
              <li><strong>New Submissions:</strong> Found a great product or spreadsheet resource? Share it with us for review and potential inclusion.</li>
              <li><strong>Safety Concerns:</strong> If you encounter any suspicious links or sellers through our directory, report them immediately.</li>
            </ul>
          </div>
          <div className="mt-8">
            <Link to="/" className="inline-flex items-center gap-2 text-primary-600 hover:text-primary-700 font-medium text-sm">
              <i className="ri-arrow-left-line"></i> Back to Home
            </Link>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}